import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { UserDataStoreService } from "../../services/user-data-store.service";
import { Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { UserManagementService } from "../../services/user-management.service";
import { UserViewModel } from "../../models/user-view-model";
import { log } from "util";

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss']
})
export class UserProfileComponent implements OnInit {

  public currentUser: UserViewModel;
  public userProfileForm: FormGroup;
  public isSubmitted: boolean = false;
  qrCodeImage: string;
  manualEntryKey: string;
  tempSecretKey: string;
  otpCode: string;
  twoFAError: string;
  qrCodeSvg: string;
  is2FAEnabled: boolean = false;


  constructor(private _userService: UserDataStoreService,
    private _userManagementService: UserManagementService,
    private _formBuilder: FormBuilder,
    private _router: Router,
    private _ngxUiLoaderService: NgxUiLoaderService) { }

  ngOnInit() {
    this._ngxUiLoaderService.start();
    this.userProfileForm = this._formBuilder.group({
      id: [0],
      lastName: ['', [Validators.required]],
      name: ['', [Validators.required]],
      phoneNumber: ['', [Validators.required]],
      otpCode: ['', [Validators.required]],
    });
    this.initUser();
  }

  public async initUser(): Promise<void> {
    this._userService.currentUser.subscribe(async loggedInUser => {
      console.log(loggedInUser);
      debugger;
      if (!!loggedInUser && !!loggedInUser.id) {
        // Set 2FA flag from loggedInUser object directly
        this.is2FAEnabled = loggedInUser.requires2FA === true;

        // Now get the full user details
        this.currentUser = await this._userManagementService.GetByUserId(loggedInUser.id);

        this.userProfileForm.controls.lastName.setValue(this.currentUser.lastName);
        this.userProfileForm.controls.name.setValue(this.currentUser.name);
        this.userProfileForm.controls.phoneNumber.setValue(this.currentUser.phoneNumber);
        this.is2FAEnabled = this.currentUser.required2FA;
      }

      this._ngxUiLoaderService.stop();
    });
  }

  public navigateResetPassword(): void {
    this._router.navigate(['./reset-password']);
  }

  public async save(): Promise<void> {
    this.isSubmitted = true;
    if (!!this.userProfileForm.valid) {
      this._ngxUiLoaderService.start();
      this.currentUser.lastName = this.userProfileForm.controls.lastName.value;
      this.currentUser.name = this.userProfileForm.controls.name.value;
      this.currentUser.phoneNumber = this.userProfileForm.controls.phoneNumber.value;
      await this._userManagementService.UpdateParticipantUser(this.currentUser);
      this._ngxUiLoaderService.stop();
    }
  };

  public async generate2FA(): Promise<void> {
    try {
      debugger;
      const response = await this._userManagementService.Generate2FASetup(this.currentUser.id);
      const result = response.body;
      console.log(result);
      debugger;
      this.qrCodeSvg = result.qrCodeSvg;
      this.manualEntryKey = result.manualEntryKey;
      this.tempSecretKey = result.tempSecretKey;
      debugger;
    } catch (err) {
      // console.error(err);
      this.twoFAError = 'Failed to generate 2FA setup.';
    }
  }

  public async verifyAndEnable2FA(): Promise<void> {
    try {
      const response = await this._userManagementService.VerifyAndEnable2FA({
        userId: this.currentUser.id,
        otpCode: this.userProfileForm.controls.otpCode.value,
        secretKey: this.manualEntryKey
      });
      console.log(response);
      debugger;
      // Check the actual response structure
      if (response.body && response.body.success) {
        // alert('Two-Factor Authentication has been enabled!');
        this.qrCodeImage = '';
        this.qrCodeSvg = '';
        this.manualEntryKey = '';
        this.twoFAError = '';

        const loggedInUser = this._userService.currentUserValue;
        loggedInUser["requires2FA"] = true;
        this._userService.UpdateUser(loggedInUser);
        this.is2FAEnabled = true;


      } else {
        this.twoFAError = response.body?.message || 'Invalid OTP code. Please try again.';
      }
    } catch (err) {
      console.error('2FA Verification Error:', err);
      this.twoFAError = err.error?.message || err.message || 'Verification failed.';
    }
  }

  public async disable2FA(): Promise<void> {
    try {
      debugger;
      const response = await this._userManagementService.Disable2FA(this.currentUser.id.toString());
      if (response.body?.success) {
        this.is2FAEnabled = false;
        this.twoFAError = '';
      }
    } catch (err) {
      this.twoFAError = 'Failed to disable 2FA.';
    }
  }
}


